import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import PdfBuilder from './pdf-helpers/builder';
@Injectable({
  providedIn: 'root',
})
export class PdfService {
  constructor(private apiService: ApiService) {}
   downloadNihlReport(id: string, fileName:string): Observable<boolean> {
    let that = this;
    return new Observable(function(observer:any){
      that.apiService.postService('report/download', {
        "reportType": "nihl-report",
        "payloadData": {
            "id": id
        }
      }).subscribe(({data}) => {
        let pb  = new PdfBuilder();
        pb.addData(data);
        let fileN =pb.save(fileName);
        observer.next(fileN);
      });
    }) 
  }
}
